import styled from 'styled-components';
import { FontWeight } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const DownloadButton = styled.div`
  button {
    padding: 8px 16px;
    font-weight: ${FontWeight.bold};
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;
